import { useNavigate } from "react-router-dom";
import apiCall from "../../../../../../apicall";
import { useEffect, useState } from "react";
import TableLoader from "../../../../../common/tableLoader";
import Toast from "../../../../../common/toast";
import { useSelector } from "react-redux";
import ConfirmationDeleteJobType from "./confirmation-delete-job-type";
import ReactQuill from "react-quill";
import Spinner from "../../../../../common/spinner";
import ConfirmationActiveJobType from "./confirmation-active-job-type";
import { Helmet } from "react-helmet-async";
import { formatCompanyName } from "../../../../../../globals/fomat-comapny-name";

function JobTypeList() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false)
    const [jobId, setJobId] = useState();
    const [jobTypes, setJobTypes] = useState([]);
    const [longDescription, setLongDescription] = useState([]);
    const { role_type, TOKEN, isLoggedIn } = useSelector((state) => state.menu);
    const [formValues, setFormValues] = useState({
        typeName: "",
        shortDescription: "",
        longDescription: "",
        relatedDocuments: "",
        relatedFields: "",
        relatedJobFields: "",
    });
    const [formErrors, setFormErrors] = useState({});
    const [expandedIndex, setExpandedIndex] = useState(null);
    const [errSuccessMesg, setErrSuccessMsg] = useState({
        message: "",
        status: "error",
    });
    const handleInputChange = (e, fieldName) => {
        const value = e?.target ? e.target.value : e; // Check if event has a target
        const name = fieldName || (e?.target?.name || "");

        setFormValues((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));

        setFormErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "",
        }));
    };
    const navigateToProfessionForm = () => {
        navigate(`/profession-form`);
    };
    const displayJobTypeErrMsg = (errMsg) => {
        setErrSuccessMsg({
            message: errMsg,
            status: false,
        });
        setIsLoading(false);
    };
    const handleSelectedJobTypeId = (id) => {
        setJobId(id);
    };
    const validateForm = () => {
        const errors = {};

        // Validate fields common to both roles
        if (!formValues.typeName || formValues.typeName.trim() === "") {
            errors.typeName = "Profession is required.";
        }

        if (!formValues.shortDescription || formValues.shortDescription.trim() === "") {
            errors.shortDescription = "Short Description is required.";
        }

        if (!formValues.longDescription || formValues.longDescription.trim() === "") {
            errors.longDescription = "Long Description is required.";
        }

        if (!formValues.relatedDocuments || formValues.relatedDocuments.trim() === "") {
            errors.relatedDocuments = "Documents are required.";
        } else {
            try {
                const parsed = JSON.parse(formValues.relatedDocuments);
                if (!Array.isArray(parsed)) {
                    errors.relatedDocuments = "Documents must be a JSON array.";
                }
            } catch (e) {
                errors.relatedDocuments = "Invalid JSON format.";
            }
        }

        if (!formValues.relatedFields || formValues.relatedFields.trim() === "") {
            errors.relatedFields = "Job Seeker Profile Questions are required.";
        } else {
            try {
                const parsed = JSON.parse(formValues.relatedFields);
                if (!Array.isArray(parsed)) {
                    errors.relatedFields = "Job Seeker Profile Questions must be a JSON array.";
                }
            } catch (e) {
                errors.relatedFields = "Invalid JSON format.";
            }
        }

        if (!formValues.relatedJobFields || formValues.relatedJobFields.trim() === "") {
            errors.relatedJobFields = "Post Job Form Questions are required.";
        } else {
            try {
                const parsed = JSON.parse(formValues.relatedJobFields);
                if (!Array.isArray(parsed)) {
                    errors.relatedJobFields = "Post Job Form Questions must be a JSON array.";
                }
            } catch (e) {
                errors.relatedJobFields = "Invalid JSON format.";
            }
        }

        // Log errors for debugging
        console.log("Validation Errors:", errors);

        setFormErrors(errors);
        return Object.keys(errors).length === 0; // Return true if no errors, false if there are errors
    };
    const displayErrMsg = (errMsg) => {
        setErrSuccessMsg({
            message: errMsg,
            status: false,
        });
    };

    const displaySuccessMsg = () => {
        setIsLoading(false);
        setErrSuccessMsg({
            message: "Profession has been updated successfully.",
            status: true,
        });
        setFormValues({
            typeName: "",
            shortDescription: "",
            longDescription: "",
            relatedDocuments: "",
            relatedFields: "",
            relatedJobFields: "",
        });
    };

    const prefillFormValues = (item) => {
        setFormValues({
            typeName: item?.typeName || "",
            shortDescription: item?.shortDescription || "",
            longDescription: item?.longDescription || "",
            relatedDocuments: JSON.stringify(JSON.parse(item?.relatedDocuments)?.docs) || [],
            relatedFields: JSON.stringify(JSON.parse(item?.relatedFields)?.fields) || [],
            relatedJobFields: JSON.stringify(JSON.parse(item?.relatedJobFields)?.fields) || [],
        });
        setJobId(item?.id); // for the edit request
    };

    const editJobType = async (event, jobTypeId) => {
        event.preventDefault();
        setIsLoading(true);

        if (validateForm()) {

            const formattedData = {
                typeName: formValues.typeName,
                shortDescription: formValues.shortDescription,
                longDescription: formValues.longDescription,
                relatedDocuments: JSON.stringify({ docs: JSON.parse(formValues.relatedDocuments) }),
                relatedFields: JSON.stringify({ fields: JSON.parse(formValues.relatedFields) }),
                relatedJobFields: JSON.stringify({ fields: JSON.parse(formValues.relatedJobFields) }),
            };

            try {
                const jobTypeResponse = await apiCall(`openstaff/jobs/${jobTypeId}/updateJobType`, "PUT", formattedData, TOKEN);
                console.log("jobTypeResponse", jobTypeResponse);

                if (jobTypeResponse?.status === 200) {
                    displaySuccessMsg();
                    getJobType();
                } else if (jobTypeResponse?.response?.status === 400) {
                    displayErrMsg(jobTypeResponse?.response?.data?.errorMessage);
                    setIsLoading(false);
                } else {
                    displayErrMsg(jobTypeResponse?.response?.data?.message);
                    setIsLoading(false);
                }
            } catch (error) {
                setIsLoading(false);
                displayErrMsg("Something went wrong!");
            }
        } else {
            setIsLoading(false);
            displayErrMsg("Check the form validation!");
        }
    };
    const getJobType = async () => {
        let endpoint;
        if (role_type.includes('ROLE_OPENSTAFF_ADMIN'))
            endpoint = `openstaff/jobs/allJobTypes`;
        else endpoint = "config/allJobTypes";
        try {
            setIsLoading(true);
            const jobTypeListResponse = await apiCall(endpoint, "GET", null, TOKEN);
            console.log("jobTypeListResponse---", jobTypeListResponse?.data);

            if (jobTypeListResponse?.data?.length > 0) {
                setJobTypes(jobTypeListResponse.data);
                // setShortDescription(jobTypeListResponse.data.shortDescription);
                setLongDescription(jobTypeListResponse.data.longDescription);
                setIsLoading(false);
            } else if (jobTypeListResponse?.data?.length == 0) {
                setJobTypes({});
                setIsLoading(false);
            } else if (jobTypeListResponse?.response?.status == 401) {
                displayJobTypeErrMsg("Your session has been expired!!");
            } else {
                displayJobTypeErrMsg(jobTypeListResponse?.response?.data?.message);
            }
        }
        catch (err) {
            console.log("err", err)
        }
    };
    const cleanHtmlContent = (html) => {
        return html
            .replace(/^"|"$/g, '')           // Remove leading and trailing quotes
            .replace(/\\&quot;/g, '"')       // Replace escaped quotes with normal quotes
            .replace(/\\"/g, '"')            // Replace escaped double quotes with normal quotes
            .replace(/\\'/g, "'");           // Replace escaped single quotes with normal quotes
    };
    useEffect(() => {
        getJobType();
    }, [])

    const limitWords = (text, wordLimit = 40) => {
        if (!text) return '';
        const words = text.split(' ');
        if (words.length > wordLimit) {
            return {
                limited: words.slice(0, wordLimit).join(' '),
                isTruncated: true
            };
        }
        return { limited: text, isTruncated: false };
    };

    return (
        <>
            <div>
                <Helmet>
                    <title>Profession Listings | List of Professions Job Platform | {formatCompanyName()}</title>
                    <meta name="description" content="Explore a comprehensive list of professions across industries. Discover career options and find the right role for your skills and interests." />
                    <meta name="keywords" content="professions list, job roles, career options, occupations, types of professions, job categories, explore careers, career paths, job titles, work opportunities" />
                </Helmet>
            </div>
            <div className="section-full p-t120  p-b90 site-bg-white">
                <div className="container">
                    <div class="panel-heading wt-panel-heading p-a20 mb-4 d-flex justify-content-between align-items-center">
                        <h3 class="wt-title">Professions</h3>
                        {role_type.includes("ROLE_OPENSTAFF_ADMIN") && (<a
                            className="site-button"
                            onClick={() => navigateToProfessionForm()}
                            role="button"
                        >
                            Add
                        </a>
                        )}
                    </div>

                    <div className="twm-candidates-list-wrap">
                        {!isLoading ? (
                            jobTypes?.length > 0 ? (
                                <div className="tw-faq-section job-list-accordion" id="job-list-accordion">
                                    {jobTypes?.map((item, index) => {
                                        const { limited, isTruncated } = limitWords(item?.longDescription, 40);
                                        const isExpanded = expandedIndex === index;
                                        // if (!isLoggedIn && !item?.active) return null;

                                        return (
                                            <div key={item?.id} className="accordion tw-faq" style={{ maxWidth: "100%" }}>
                                                <div className="accordion-item">
                                                    <button
                                                        className="accordion-button collapsed"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target={`#hireApplicant-${index}`}
                                                        aria-expanded="false"
                                                        aria-controls={`hireApplicant-${index}`}
                                                        onClick={(e) => {
                                                            if (role_type.includes('ROLE_OPENSTAFF_ADMIN')) {
                                                                prefillFormValues(item); // Call the prefillFormValues function
                                                            }
                                                        }}
                                                    >
                                                        <div className="d-flex justify-content-between align-items-center" style={{ width: "100%" }}>
                                                            <div>
                                                                <span>{item.typeName}</span>
                                                                <p className="mb-0 text-muted d-block" style={{ fontSize: "14px" }}>{item.shortDescription}</p>
                                                            </div>
                                                            {role_type.includes('ROLE_OPENSTAFF_ADMIN') && (
                                                                <div className="me-5 mt-3 ms-3">
                                                                    <p style={{ color: item?.active ? "green" : "red" }}>
                                                                        {item?.active ? "Enabled" : "Disabled"}
                                                                    </p>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </button>
                                                    <div
                                                        id={`hireApplicant-${index}`}
                                                        className="accordion-collapse collapse"
                                                        data-bs-parent="#job-list-accordion"
                                                    >
                                                        <div className="accordion-body">
                                                            {!isLoggedIn && (
                                                                <div className="description-text">
                                                                    <span className="profession-list-long-desc-text"
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: cleanHtmlContent(isExpanded ? item?.longDescription : limited)
                                                                        }}
                                                                    />
                                                                    {isTruncated && (
                                                                        <span style={{ whiteSpace: 'nowrap' }}>
                                                                            {!isExpanded && '.......... '}
                                                                            <b><a
                                                                                className="site-text-primary job-details"
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => setExpandedIndex(isExpanded ? null : index)}
                                                                            >
                                                                                {isExpanded ? 'Show Less' : 'Read More'}
                                                                            </a></b>
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            )}
                                                            {/* <p>
                                                                <b>
                                                                    <a
                                                                        className="twm-jobs-browse site-text-primary job-details mt-3"
                                                                        data-bs-toggle="modal"
                                                                        href={"#job-type-popup"}
                                                                        onClick={() => setLongDescription(cleanHtmlContent(item?.longDescription))}
                                                                    >
                                                                        Read More
                                                                    </a>
                                                                </b>
                                                            </p> */}
                                                            {role_type.includes('ROLE_OPENSTAFF_ADMIN') && (
                                                                <div className="twm-candidates-list-style1 mb-5"
                                                                >
                                                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 row">
                                                                        {role_type.includes('ROLE_OPENSTAFF_ADMIN') && (
                                                                            <div className="col-xl-10 col-lg-12 col-md-12 col-sm-12 twm-job-self-bottom">
                                                                                <form id="jobseeker_profile">
                                                                                    <div className="panel panel-default">
                                                                                        <div className="panel-body wt-panel-body p-a20 m-b30 ">
                                                                                            <div className="row">
                                                                                                <div className="col-xl-6 col-lg-6 col-md-12">
                                                                                                    <div className="form-group">
                                                                                                        <label>Profession</label>
                                                                                                        <div className="ls-inputicon-box">
                                                                                                            <input
                                                                                                                className="form-control"
                                                                                                                name="typeName"
                                                                                                                type="text"
                                                                                                                placeholder="Profession"
                                                                                                                value={formValues?.typeName !== undefined ? formValues?.typeName : item?.typeName || ""}
                                                                                                                onChange={(e) => handleInputChange(e, "typeName")}
                                                                                                            />
                                                                                                        </div>
                                                                                                        {formErrors?.typeName && (
                                                                                                            <span className="error-message">
                                                                                                                {formErrors?.typeName}
                                                                                                            </span>
                                                                                                        )}
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div className="col-xl-6 col-lg-6 col-md-12">
                                                                                                    <div className="form-group">
                                                                                                        <label>Short Description</label>
                                                                                                        <div className="ls-inputicon-box">
                                                                                                            <input
                                                                                                                className="form-control"
                                                                                                                name="shortDescription"
                                                                                                                type="text"
                                                                                                                placeholder="Short Description"
                                                                                                                value={formValues?.shortDescription !== undefined ? formValues?.shortDescription : item?.shortDescription || ""}
                                                                                                                onChange={(e) => handleInputChange(e, "shortDescription")}
                                                                                                            />
                                                                                                        </div>
                                                                                                        {formErrors.shortDescription && (
                                                                                                            <span className="error-message">
                                                                                                                {formErrors?.shortDescription}
                                                                                                            </span>
                                                                                                        )}
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div className="col-xl-12 col-lg-12 col-md-12">
                                                                                                    <div className="form-group city-outer-bx has-feedback">
                                                                                                        <label>Long Description</label>
                                                                                                        <div className="ls-inputicon-box">
                                                                                                            <ReactQuill
                                                                                                                theme="snow"
                                                                                                                value={formValues?.longDescription || ""}
                                                                                                                onChange={(value) => handleInputChange(value, "longDescription")}
                                                                                                                placeholder="Long Description"
                                                                                                                modules={{
                                                                                                                    toolbar: [
                                                                                                                        [{ 'font': [] }],
                                                                                                                        [{ size: [] }],
                                                                                                                        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                                                                                                        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                                                                                                        ['link', 'image'],
                                                                                                                        ['clean']
                                                                                                                    ]
                                                                                                                }}
                                                                                                                formats={[
                                                                                                                    'header', 'font', 'size',
                                                                                                                    'bold', 'italic', 'underline', 'strike', 'blockquote',
                                                                                                                    'list', 'bullet',
                                                                                                                    'link', 'image', 'video'
                                                                                                                ]}
                                                                                                            />
                                                                                                            {formErrors?.longDescription && (
                                                                                                                <span className="error-message">
                                                                                                                    {formErrors?.longDescription}
                                                                                                                </span>
                                                                                                            )}
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                {/* Documents fields */}
                                                                                                <div className="col-xl-12 col-lg-12 col-md-12">
                                                                                                    <div className="form-group">
                                                                                                        <label>Documents (JSON) </label>
                                                                                                        <span
                                                                                                            style={{ marginLeft: 5, cursor: "pointer" }}
                                                                                                            title={`[{
    "mapRecordInternalId": "3",
    "required": "false"
  }]`}
                                                                                                            data-bs-toggle="tooltip"
                                                                                                            data-bs-placement="top">
                                                                                                            <i className="fa fa-info-circle" ></i>
                                                                                                        </span>
                                                                                                        <div className="ls-inputicon-box">
                                                                                                            <textarea
                                                                                                                className="form-control custom-textarea"
                                                                                                                name="relatedDocuments"
                                                                                                                value={formValues.relatedDocuments}
                                                                                                                onChange={(e) => handleInputChange(e, "relatedDocuments")}
                                                                                                                rows={10}
                                                                                                                cols={50}
                                                                                                            />

                                                                                                        </div>
                                                                                                        {formErrors.relatedDocuments && (
                                                                                                            <span className="error-message">{formErrors.relatedDocuments}</span>
                                                                                                        )}
                                                                                                    </div>
                                                                                                </div>

                                                                                                {/* Profile fields */}
                                                                                                <div className="col-xl-12 col-lg-12 col-md-12">
                                                                                                    <div className="form-group">
                                                                                                        <label>Job Seeker Profile Questions (JSON)</label>
                                                                                                        <span
                                                                                                            style={{ marginLeft: 5, cursor: "pointer" }}
                                                                                                            title={`[{
    "title": "What is the age group of the class?",
    "mapField": "strFld1",
    "required": true
  }]`}
                                                                                                            data-bs-toggle="tooltip"
                                                                                                            data-bs-placement="top">
                                                                                                            <i className="fa fa-info-circle" ></i>
                                                                                                        </span>
                                                                                                        <div className="ls-inputicon-box">
                                                                                                            <textarea
                                                                                                                className="form-control custom-textarea"
                                                                                                                name="relatedFields"
                                                                                                                value={formValues.relatedFields}
                                                                                                                onChange={(e) => handleInputChange(e, "relatedFields")}
                                                                                                                rows={10}
                                                                                                                cols={50}
                                                                                                            />

                                                                                                        </div>
                                                                                                        {formErrors.relatedFields && (
                                                                                                            <span className="error-message">{formErrors.relatedFields}</span>
                                                                                                        )}
                                                                                                    </div>
                                                                                                </div>

                                                                                                {/* Job fields */}
                                                                                                <div className="col-xl-12 col-lg-12 col-md-12">
                                                                                                    <div className="form-group">
                                                                                                        <label>Post Job Form Questions (JSON)</label>
                                                                                                        <span
                                                                                                            style={{ marginLeft: 5, cursor: "pointer" }}
                                                                                                            title={`[{
    "title": "What is the age group of the class?",
    "mapField": "strFld1",
    "required": true
  }]`}
                                                                                                            data-bs-toggle="tooltip"
                                                                                                            data-bs-placement="top">
                                                                                                            <i className="fa fa-info-circle" ></i>
                                                                                                        </span>
                                                                                                        <div className="ls-inputicon-box">
                                                                                                            <textarea
                                                                                                                className="form-control custom-textarea"
                                                                                                                name="relatedJobFields"
                                                                                                                value={formValues.relatedJobFields}
                                                                                                                onChange={(e) => handleInputChange(e, "relatedJobFields")}
                                                                                                                rows={10}
                                                                                                                cols={50}
                                                                                                            />

                                                                                                        </div>
                                                                                                        {formErrors.relatedJobFields && (
                                                                                                            <span className="error-message">{formErrors.relatedJobFields}</span>
                                                                                                        )}
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div className="row col-lg-6 col-md-12">
                                                                                                    <ul className="nav" id="myTab" role="tablist">
                                                                                                        <li className="nav-item" role="presentation">
                                                                                                            <button type="button" className="site-button ms-3"
                                                                                                                onClick={(e) => editJobType(e, item?.id)}
                                                                                                            >
                                                                                                                {isLoading ? <Spinner /> : "Save Changes"}
                                                                                                            </button>
                                                                                                        </li>
                                                                                                    </ul>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </form>
                                                                            </div>
                                                                        )}
                                                                        {item?.active && (<div className="col-xl-2 col-lg-12 col-md-12 col-sm-12 twm-job-self-bottom">
                                                                            {role_type.includes('ROLE_OPENSTAFF_ADMIN') && (
                                                                                <span
                                                                                    className="site-text-primary job-details"
                                                                                >
                                                                                    <a
                                                                                        className="nav-link site-button"
                                                                                        data-bs-toggle="modal"
                                                                                        href="#delete_job_type_popup"
                                                                                        role="button"
                                                                                        onClick={() => handleSelectedJobTypeId(item?.id)}
                                                                                        style={{ backgroundColor: "red", marginTop: "20px" }}
                                                                                    >
                                                                                        Disable
                                                                                    </a>
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                        )}
                                                                        {!item.active &&
                                                                            (<div className="col-xl-2 col-lg-12 col-md-12 col-sm-12 twm-job-self-bottom">
                                                                                {role_type.includes('ROLE_OPENSTAFF_ADMIN') && (
                                                                                    <span
                                                                                        className="site-text-primary job-details"
                                                                                    >
                                                                                        <a
                                                                                            className="nav-link site-button"
                                                                                            data-bs-toggle="modal"
                                                                                            href="#active_job_type_popup"
                                                                                            role="button"
                                                                                            onClick={() => handleSelectedJobTypeId(item?.id)}
                                                                                            style={{ marginTop: "20px" }}
                                                                                        >
                                                                                            Enable
                                                                                        </a>
                                                                                    </span>
                                                                                )}
                                                                            </div>
                                                                            )}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            ) : (
                                ""
                            )
                        ) : (
                            <TableLoader />
                        )}
                    </div>
                </div>
            </div>
            <ConfirmationDeleteJobType
                jobId={jobId}
                getJobType={getJobType}
                setErrSuccessMsg={setErrSuccessMsg}
            />
            <ConfirmationActiveJobType
                jobId={jobId}
                getJobType={getJobType}
                setErrSuccessMsg={setErrSuccessMsg}
            />
            {errSuccessMesg?.message != "" ? <Toast message={errSuccessMesg} /> : ""}
        </>
    )
}

export default JobTypeList;